import { render, staticRenderFns } from "./VoucherCardClaim.vue?vue&type=template&id=2b1a14fe&"
import script from "./VoucherCardClaim.vue?vue&type=script&lang=js&"
export * from "./VoucherCardClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports